<template>
  <div v-if="isPFTT" id="trainBanner">
    <div class="banner" :style="{ backgroundImage: bannerStyle }"></div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed, watch } from 'vue';
import type {Ref, ComputedRef} from 'vue';
import bannerDesktopTrain from '@/images/train_banner.png';
import bannerMobileTrain from '@/images/train_banner_mobile.png';
import { isMobile as checkIsMobile } from '@/utils/utils.js';
import {pfttPlusSevenCriteria} from '@/config/pfttPlusSevenCriteria';
import store from "@/vue/planning/store/store";

// Setup reactive variables
const isMobile: Ref<boolean> = ref(false);
const isPFTT: Ref<boolean> = ref(false);

const checkIsPFTT = (): void => {
  const packageCode:string | null = store.state.packCode
  const hasBannerCriteria = window.lihe.criteriasList.includes(pfttPlusSevenCriteria)

  if (['PFTT', 'HTT'].includes(packageCode) && hasBannerCriteria) {
    isPFTT.value = true;
  } else {
    isPFTT.value = false;
  }
};

// Computed property for banner style
const bannerStyle: ComputedRef<string> = computed(() => {
  return `url(${isMobile.value ? bannerMobileTrain : bannerDesktopTrain})`
});

watch(
  () => store.state.packCode,
  () => {
    checkIsPFTT()
  }
);

onMounted(() => {
  isMobile.value = checkIsMobile();
  checkIsPFTT();
});
</script>

<style scoped>
.trainBanner{
  width: 1320px;
}

.banner {
  height: 245px;
  background-size: contain;
  background-repeat: no-repeat;
}

@media screen and (max-width: 770px) {
  .banner {
    height: 140vw;
  }
}
</style>